import React from 'react';
import { FlowLogsView } from 'js/components/pipelines/list/FlowLogsView';

interface FlowLogsProps {
  source: number;
}

export const FlowLogs = (props: FlowLogsProps) => {
  if (!props.source) return null;
  return <FlowLogsView dataSource={props.source} runId={-1} theme="light" />;
};
